import { Navigate, useLocation } from 'react-router-dom';

// Redirects a renamed route to its new path, keeping the rest of the URL
// (sub-path, query and hash) so old bookmarks and e-mail links keep working.
const LegacyPathRedirect = ({ from, to }) => {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.startsWith(from) ? pathname.slice(from.length) : '';

  return <Navigate to={`${to}${rest}${search}${hash}`} replace />;
};

export default LegacyPathRedirect;
